<template>
  <div class="question">
    <div class="top">
      <h1 class="question-title">更新日志</h1>
      <div class="end">
        <div class="end-box">
          <div class="menu">
            <el-menu
              :default-active="index.toString()"
              background-color="#304fae"
              text-color="#fff"
              active-text-color="#021b64"
              @select="menuItemClick"
            >
              <el-menu-item
                v-for="(list, index) in updateLogs"
                :key="index"
                :index="index.toString()"
              >
                <span>{{ list.label }}</span>
              </el-menu-item>
            </el-menu>
          </div>
          <div class="content">
            <div
              v-for="(log, idx) in updateLogs"
              :key="idx"
              v-show="index === idx"
            >
              <div class="info">
                <span class="label">更新日期：</span>
                <span>{{ log.label }}</span>
              </div>
              <template
                v-for="(item, itemIdx) in log.versionList"
                :key="itemIdx"
              >
                <div class="info">
                  <span class="label">版本：</span>
                  <span>{{ item.version }}</span>
                </div>
                <div class="info">更新内容：</div>
                <div class="content-update">
                  <ul>
                    <li v-for="log in item.logs" :key="log">
                      {{ log }}
                    </li>
                  </ul>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <on-trial-vue />
    </div>
  </div>
</template>

<script>
import OnTrialVue from '@/components/OnTrial.vue';
export default {
  metaInfo: {
    title: '更新日志 | 小美客服系统',
    meta: [
      {
        name: 'keyWords',
        content:
          '在线客服,小美客服、小美客服系统、小美客服软件、客服系统、客服软件、智能客服系统、智能客服软件、智能机器人、工单系统、在线客服',
      },
      {
        name: 'description',
        content:
          '小美客服系统是通过多种渠道提供即时、高效和个性化的服务。我们系统利用人工智能、大数据分析和机器学习等技术，实现智能分流、自动回复和问题识别等功能，大大提升客户服务效率与满意度。同时，我们的客服系统还能收集客户反馈，帮助企业优化产品和服务，增强竞争力。',
      },
    ],
  },
  components: {
    OnTrialVue,
  },
  data() {
    return {
      updateLogs: [
        {
          label: '2026-07',
          versionList: [
            {
              version: '2.4.0（WEB）',
              logs: [
                '1、新增消息引用功能',
                '2、新增忘记密码功能',
                '3、对话分配新增依次分配方案',
                '4、新增线上支付功能',
                '5、优化对话框拖拽发送，支持文件/视频/图片等资源一键发送',
                '6、新增区域屏蔽功能',
                '7、优化强制下线提示，提示信息更加明确',
                '8、优化推广消息推送体验',
                '9、AI 机器人支持连锁问答、热门问题等能力',
              ],
            },
            {
              version: '1.0.0（comm-web）',
              logs: [
                '1、新增企业注册功能',
                '2、新增企业认证功能',
                '3、新增企业认证审核页',
                '4、更新隐私政策与用户协议',
              ],
            },
          ],
        },
        {
          label: '2026-04',
          versionList: [
            {
              version: '1.2.2（WEB）',
              logs: [
                '1、新增企业微信功能',
                '2、邀请评价功能优化',
                '3、多站点管理功能优化',
                '4、工单留言功能优化',
                '5、对话转接功能优化',
                '6、黑名单管理优化',
                '7、修复已知其他问题',
              ],
            },
          ],
        },
        {
          label: '2025-08',
          versionList: [
            {
              label: '2025-08',
              version: '1.2.1（PC桌面端）',
              logs: [
                '1、系统已知问题优化',
                '2、优化线路选择问题',
                '3、修复已知其他问题',
              ],
            },
            {
              version: '1.2.1（WEB）',
              logs: [
                '1、新增内部对话功能',
                '2、新增置顶对话功能',
                '3、新增AI智能客服接入',
                '4、访客页面优化',
                '5、已知bug修复',
              ],
            },
          ],
        },
        {
          label: '2025-05',
          versionList: [
            {
              label: '2025-05',
              version: '1.1.17（移动端）',
              logs: [
                '1、修复ios已知问题',
                '2、更新界面交互样式，优化界面统一性',
                '3、强化用户多媒体传输稳定性',
              ],
            },
            {
              version: '1.2.0（PC桌面端）',
              logs: ['1、系统稳定性优化', '2、优化访客端发送回复逻辑'],
            },
          ],
        },
        {
          label: '2025-02',
          versionList: [
            {
              version: '1.1.12（移动端）',
              logs: [
                '1、修复iOS已知问题',
                '2、加强用户隐身状态确认',
                '3、优化移动端下载功能',
              ],
            },
          ],
        },
        {
          label: '2024-11',
          versionList: [
            {
              version: '1.1.10（PC桌面端）',
              logs: [
                '1、小美客服性能提升',
                '2、紧急修复小美客服安全补丁',
                '3、用户核心功能体验优化',
                '4、修复当前访客端已知缺陷',
              ],
            },
          ],
        },
        {
          label: '2024-09',
          versionList: [
            {
              version: '1.1.5（移动端）',
              logs: [
                '1、移动端登录功能更新，便捷移动端用户切换登录',
                '2、新增单条消息翻译功能',
                '3、优化访客离线状态显示图标',
              ],
            },
          ],
        },
        {
          label: '2024-08',
          versionList: [
            {
              version: '1.1.2（移动端）',
              logs: [
                '1、修复了移动端已知问题',
                '2、优化了消息提示功能',
                '3、提高移动端多媒体播放流畅度',
              ],
            },
          ],
        },
        {
          label: '2023-12',
          versionList: [
            {
              version: '1.1.9（PC桌面端）',
              logs: [
                '1、已读未读功能更新',
                '2、多站点管理功能更新',
                '3、修复更新部分API',
                '4、管理端IP解锁功能',
                '5、完善修复其他已知问题',
              ],
            },
          ],
        },
        {
          label: '2023-11',
          versionList: [
            {
              version: '1.1.8（PC桌面端）',
              logs: [
                '1、新版官网上线',
                '2、修复服务器漏洞bug',
                '3、完善认证体系功能模块',
              ],
            },
          ],
        },
        {
          label: '2023-10',
          versionList: [
            {
              version: '1.1.7（PC桌面端）',
              logs: ['1、完善关键词品控体系', '2、完善视频审核模块'],
            },
          ],
        },
        {
          label: '2023-07',
          versionList: [
            {
              version: '1.1.1（移动端）',
              logs: ['1、修复安卓APP已知问题', '2、修复ios端已知问题'],
            },
          ],
        },
        {
          label: '2023-05',
          versionList: [
            {
              version: '1.1.3（PC桌面端）',
              logs: [
                '1、更新企业和个人实名认证上传管理功能',
                '2、下线调整抖音私信功能',
              ],
            },
          ],
        },
      ],
      index: 0,
    };
  },
  methods: {
    menuItemClick(index) {
      this.index = parseInt(index);
    },
  },
};
</script>

<style scoped lang="less">
.question {
  min-height: 100vh;
  background: #f5f7fa;
}

.top {
  width: 100%;
  background: linear-gradient(90deg, #00269a, #020c2f);
  padding-bottom: 40px;
}

.question-title {
  color: #fff;
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  padding: 120px 0 60px;
  margin: 0;

  @media screen and (max-width: 700px) {
    font-size: 28px;
    padding: 80px 0 40px;
  }
}

.end {
  display: flex;
  justify-content: center;
  padding: 0 20px;
}

.end-box {
  display: flex;
  width: 100%;
  max-width: 1200px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  @media screen and (max-width: 700px) {
    flex-direction: column;
  }
}

.menu {
  width: 200px;
  background: #304fae;
  overflow-y: auto;

  @media screen and (max-width: 700px) {
    width: 100%;
    max-height: 200px;
  }
}

::v-deep .el-menu {
  border: none;
}

::v-deep .el-menu-item {
  color: #fff;
  font-size: 16px;
  height: 60px;
  line-height: 60px;
  transition: all 0.3s ease;

  @media screen and (max-width: 700px) {
    font-size: 14px;
    height: 50px;
    line-height: 50px;
  }
}

::v-deep .el-menu-item.is-active {
  background: #fff !important;
  color: #021b64 !important;
  font-weight: 600;
}

::v-deep .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
}

.content {
  flex: 1;
  padding: 40px;
  background: #fff;

  @media screen and (max-width: 700px) {
    padding: 20px;
  }
}

.info {
  color: #021b64;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;

  @media screen and (max-width: 700px) {
    font-size: 16px;
  }

  .label {
    font-weight: 600;
  }

  span {
    font-weight: 400;
  }
}

.content-update {
  border: 1px solid #304fae;
  border-radius: 8px;
  padding: 20px;
  background: #f9fafc;
  margin-bottom: 20px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      color: #304fae;
      font-size: 16px;
      margin: 10px 0;
      line-height: 1.5;

      @media screen and (max-width: 700px) {
        font-size: 14px;
      }
    }
  }
}

.bottom {
  margin-top: 60px;
  position: relative;
  bottom: 0;
  width: 100%;

  @media screen and (max-width: 700px) {
    margin-top: 40px;
  }
}
</style>
